import {Component, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ApplicantRequestService} from '../service/applicant-request.service';
import {PaymentModel} from '../model/payment.model';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {TokenStorageService} from '../shared/service/token-storage.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {
  paymentSearchForm: FormGroup;
  public PaymentModel: PaymentModel[];
  paymentModels: PaymentModel = new PaymentModel();
  public userName: string;
  public type: string;

  displayedColumns: string[] = ['refNo', 'reqId' , 'nic', 'name', 'appType', 'createdTime', 'action'];
  dataSource: MatTableDataSource<any>;


  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private applicantRequestService: ApplicantRequestService,
              private tokenStorageService: TokenStorageService,
              private route: ActivatedRoute,) {
    this.route.paramMap.subscribe(params => {
      this.type = params.get('type');
    });
  }

  ngOnInit() {
    this.paymentSearchForm = new FormGroup({
      paymentRefNo: new FormControl(null),
      name: new FormControl(null),
      nic: new FormControl(null),
      cdcNo: new FormControl(null),
    });

    this.onSearch();
  }

  onSearch() {
    this.paymentModels.paymentRefNo = this.paymentSearchForm.value.paymentRefNo;
    this.paymentModels.name = this.paymentSearchForm.value.name;
    this.paymentModels.nic = this.paymentSearchForm.value.nic;
    this.paymentModels.cdcNo = this.paymentSearchForm.value.cdcNo;
    this.paymentModels.applicationType = this.type;

    this.applicantRequestService.searchPaymentPendingData(this.paymentModels).subscribe(
      (result: any ) => {
        this.PaymentModel = result;
        this.dataSource = new MatTableDataSource(this.PaymentModel);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }



}
